import { render, staticRenderFns } from "./ActivityFeedItemIcons.vue?vue&type=template&id=6aa5621f&scoped=true&"
import script from "./ActivityFeedItemIcons.vue?vue&type=script&setup=true&lang=js&"
export * from "./ActivityFeedItemIcons.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ActivityFeedItemIcons.vue?vue&type=style&index=0&id=6aa5621f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa5621f",
  null
  
)

export default component.exports